import { render } from "./Slider.vue?vue&type=template&id=3febc513&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=3febc513&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3febc513"

export default script